enum DynamicFieldsType {
  AUTOCOMPLETE = 'AUTOCOMPLETE',
  CHECKBOX = 'CHECKBOX',
  DATE_FIELD = 'DATE_FIELD',
  DYNAMIC_FIELDS = 'DYNAMIC_FIELDS',
  FIELD = 'FIELD',
  FIELD_SET = 'FIELD_SET',
  INPUT = 'INPUT',
  RADIO_GROUP = 'RADIO_GROUP',
  TEXT = 'TEXT',
  TEXT_AREA = 'TEXT_AREA',
}

export default DynamicFieldsType;
